var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-form-part"},[_c('ServiceSelectionField',_vm._g({attrs:{"choices":_vm.serviceSelections},on:{"result":function($event){return _vm.setServiceForSelection($event.value[0])}}},_vm.$listeners)),_vm._v(" "),_c('ServiceField',_vm._g({ref:"service",attrs:{"hidden":""}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }